export default __webpack_public_path__ + "static/media/emptyCircledollar.f939391b.svg";